import { gql } from "@apollo/client";

export const setExperiencedDismissed = gql`
    mutation SetExperienceDismissed($input: SetExperienceDismissedRequest!) {
        setExperienceDismissed(input: $input)
    }
`;
